<page-content [fullPageWidth]="true">
    <header-elitment header
            [hasSideMenu]="true">
    </header-elitment>
    <side-menu left-menu>
        <athlete-side-menu></athlete-side-menu>
    </side-menu>

    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>

    <module-content *ngIf="!isLoading && !is401 && !is404" title="{{ 'Documents'|translate }}"
                    [mainActions]="mainActions"
    >
      <div class="search-bar">
        <mat-form-field color="primary" class="">
            <input matInput
                   type="text"
                   maxlength="255"
                   placeholder="{{ 'Filter' | translate }}"
                   #filterKeyUp
                   (keyup)="onFilterKeyup(filterKeyUp.value)" />
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>

        <mat-table *ngIf="dataSource.count > 0"
                   [dataSource]="dataSource"
                   matSort>
            <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns"></mat-row>

            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef class="name-cell">{{ 'Name' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                        <div>{{ row.originalName }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="createDate">
                <mat-header-cell *matHeaderCellDef class="name-cell">{{ 'CreatedAt' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div>{{ row.createDate|appDate:'mediumDate' }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="size">
                <mat-header-cell *matHeaderCellDef class="name-cell">{{ 'Size' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div>{{ row.size | bytes:1 }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
                <mat-header-cell  mat-header-cell *matHeaderCellDef class="cell-right"></mat-header-cell>
                <mat-cell mat-cell *matCellDef="let row;  let i = index" class="cell-right">
                    <button
                        *ngIf="row.mimeType.indexOf('image/') == 0"
                        [disabled]="!row.rights.view"
                        mat-icon-button
                        (click)="onPreviewClicked(row)">
                        <mat-icon>search</mat-icon>
                    </button>
                    <button
                        [disabled]="!row.rights.download"
                        mat-icon-button
                        (click)="download(row)">
                        <mat-icon>cloud_download</mat-icon>
                    </button>
                    <button
                        *ngIf="row.rights.delete"
                        mat-icon-button
                        [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" xPosition="before">
                        <button
                            [disabled]="!row.rights.delete"
                            mat-menu-item
                            (click)="onRenameClicked(row)">
                            <mat-icon>edit</mat-icon>
                            <span>{{ 'DocumentRename' | translate }}</span>
                        </button>
                        <button
                            [disabled]="!row.rights.delete"
                            mat-menu-item
                            (click)="onDeleteClicked(row)">
                            <mat-icon>delete</mat-icon>
                            <span>{{ 'Delete' | translate }}</span>
                        </button>
                    </mat-menu>
                </mat-cell>
            </ng-container>
        </mat-table>
        <mat-paginator #paginator
                       [class.hidden]="dataSource.count == 0"
                       [pageSizeOptions]="[10]"
                       hidePageSize
                       showFirstLastButtons
                       [pageSize]="pageSize"
                       [length]="totalSize"
                       [pageIndex]="currentPage"
                       (page)="onPaginateChange($event)"
        >
        </mat-paginator>

        <div fxLayout="row" fxLayoutAlign="space-evenly center" class="mb-40" *ngIf="dataSource.count == 0">
            <p>{{ 'NoDocumentAtTheMoment'|translate }}</p>
        </div>

</module-content>
</page-content>
